import { Injectable } from '@angular/core';
import { CoreService } from './core.service';
import { ShapeCreatorService } from './shape-creator.service';
import { PolygonTool } from '../utils/polygon-tool';
import { CoresService } from './cores.service';
import { GlobeService } from './globe.service';


@Injectable({ providedIn: 'root' })
export class PolygonCreatorService extends ShapeCreatorService {
  private polyTool: any;
  private options: any;

  constructor(private core: CoresService,
    private globeService: GlobeService
  ) {
    super();
  }

  private ensurePolyTool() {
    if (!this.polyTool) {
      const viewer = this.globeService.getViewer();
      const container = viewer && viewer.container ? viewer.container : undefined;
      if (!container) {
        throw new Error('PolygonCreatorService: Cesium viewer container is not available.');
      }
     
      this.polyTool = new PolygonTool(this.core.getScene(), container);
    }
  }

  setCallbackOptions(callbackOptions: any, defaultSurfaceOptions?: any): void {
    this.options = { ...defaultSurfaceOptions, ...callbackOptions };
  }

  override startShapeCreationEditor(): void {
    this.ensurePolyTool();
    this.polyTool.startDrawingShape(true, this.options);
  }

  override startShapeEditEditor(): void {
   
  }

  override stopShapeEditor(): void {
    if (this.polyTool) {
      this.polyTool.stopDrawingShape();
    }
  }

  freezeShapeEditor(): void {
    if (this.polyTool) {
      this.polyTool.freezeDrawingShape();
    }
  }

  override getCurrentShape(): any {
    if (this.polyTool) {
      return this.polyTool.getCurrentShape();
    }
    return undefined;
  }

  clearShape(): void {
    if (this.polyTool) {
      this.polyTool.stopDrawingShape();
    }
  }
}